import { Button } from "../../../../ui"
import { Therapists } from "../../../../shared/Therapists"
import { CliniciansButtonContainer, CliniciansContainer } from "./styled"

export const Clinicians = () => {
  return (
    <CliniciansContainer>
      <Therapists variant="clinicians" background="transparent" hideViewBio />
      <h3>Find your care team</h3>
      <CliniciansButtonContainer>
        <Button to="/find-a-therapist" text="Find a therapist" />
        <Button to="/find-a-prescriber" text="Find a prescriber" />
      </CliniciansButtonContainer>
    </CliniciansContainer>
  )
}
